export default {
    'id': {
        display: {
            name: '編號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'id',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'email': {
        display: {
            name: '電子郵件',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'email',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            name: 'email'
        }
    },
    'username': {
        display: {
            name: '姓名',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'username',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            name: 'username'
        }
    },
    'password': {
        display: {
            name: '密碼',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'password',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'password',
            name: 'password'
        }
    },
    'status': {
        display: {
            name: '帳號狀態',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'status',
            data_type: 'string',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'org_name': {
        display: {
            name: '組織名稱',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'org_name',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            name: 'org_name',
            options: {
                type: 'fixed',
                list: [
                    { label: '處長室', value: '處長室' },
                    { label: '林政課', value: '林政課' },
                    { label: '治山課', value: '治山課' },
                    { label: '作業課', value: '作業課' },
                    { label: '育樂課', value: '育樂課' },
                    { label: '秘書室', value: '秘書室' },
                    { label: '人事室', value: '人事室' },
                    { label: '主計室', value: '主計室' },
                    { label: '政風室', value: '政風室' },
                ]
            }
        }
    },
    'roles': {
        display: {
            name: '角色',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'roles',
            data_type: 'role-array',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select',
            name: 'fk_role_id',
            options: {
                type: 'vuex',
                name: 'available_roles',
                label: 'name',
                value: 'id' // resource id
            }
        }
    },
}
  